import { render, staticRenderFns } from "./Renovacion.vue?vue&type=template&id=027b9c48&"
import script from "./Renovacion.vue?vue&type=script&lang=js&"
export * from "./Renovacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports